<template>
	<span class="key-combination">
		<span v-for="key in keys" :key="key" class="key-combination__key" v-html="key"/>
	</span>
</template>
<script>
export default {
	props: {
		keys: {
			required: true,
			type: Array,
		},
	},
};
</script>
